import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import Footer from '../../components/Footer';
import RecordingPlayer from '../../components/Player/recording-player/recording-player';
import { routes } from '../../config';
import { HeaderDisplayType, HeaderInteractionType, RootState } from '../../interfaces';
import { NestedRoutes } from '../../routes/nested-routes';
import Header from '../app/Header';
import StickyHeader from '../app/StickyHeader';
import Search from '../globalsearch';
import PvrCollection from './PvrCollection';
import PvrDeleteEpisodes from './PvrDeleteEpisodes';
import PvrDeleteSeasons from './PvrDeleteSeasons';
import PvrDeleteSeries from './PvrDeleteSeries';
import PvrFrontPage from './PvrFrontPage';
import PvrScheduled from './PvrScheduled';

export default function PvrViews() {
  const isGuest = useSelector((state: RootState) => state.authReducer.isGuest);

  const { t } = useTranslation();

  if (isGuest) {
    return (
      <div>
        <StickyHeader />
        <Header
          displayType={HeaderDisplayType.Solid}
          title={t('recordings')}
          interactionType={HeaderInteractionType.Full}
        />
        <h2 className="h2-login-needed">{t('log in to see recordings')}</h2>
        <Footer />
      </div>
    );
  }

  const paths = {
    frontPage: '/',
    scheduled: routes.pvr.scheduled,
    deleteEpisodes: routes.pvr.delete + '/:id/:seasonNum',
    deleteSeasons: routes.pvr.delete + '/:id',
    deleteSeries: routes.pvr.delete,
    play: routes.pvr.play + '/:id',
  };

  return (
    <NestedRoutes>
      <Route path={paths.frontPage} exact>
        <PvrFrontPage />
      </Route>

      <Route path={paths.scheduled}>
        <PvrScheduled />
      </Route>

      <Route path={paths.deleteEpisodes}>
        <PvrDeleteEpisodes />
      </Route>

      <Route path={paths.deleteSeasons}>
        <PvrDeleteSeasons />
      </Route>

      <Route path={paths.deleteSeries}>
        <PvrDeleteSeries />
      </Route>

      <Route path={paths.play}>
        <RecordingPlayer />
      </Route>

      <Route path="/:genreSlug" exact>
        <PvrCollection />
      </Route>

      <Route path={routes.search.base + '*'}>
        <Search />
      </Route>
    </NestedRoutes>
  );
}
